//[0-9]
var NumberToken = function() {};
NumberToken.prototype.toKendo = function() {
    return "0";
};
NumberToken.prototype.toExample = function() {
    return ["5", "2", "4", "3"];
};
//[a-zA-Z]
var Alpha = function() {};
Alpha.prototype.toKendo = function() {
    return "L";
};
Alpha.prototype.toExample = function() {
    return ["c", "Z", "y", "M"];
};
//Custom format: [A-Z]
var Upper = function() {};
Upper.prototype.toKendo = function() {
    return "u";
};
Upper.prototype.toExample = function() {
    return ["T", "P"];
};
//Custom format: [a-z]
var Lower = function() {};
Lower.prototype.toKendo = function() {
    return "l";
};
Lower.prototype.toExample = function() {
    return ["t", "p"];
};
//[a-zA-Z0-9]
var AlphaNumber = function() {};
AlphaNumber.prototype.toKendo = function() {
    return "A";
};
AlphaNumber.prototype.toExample = function() {
    return ["A", "c", "8", "7"];
};
//.
var Wild = function() {};
Wild.prototype.toKendo = function() {
    return "*";
};
Wild.prototype.toExample = function() {
    return ["6", "^", "@", "(", "a", "b"];
};
var Raw = function(char) {
    this.char = char;
};
//This map contains all of the masks that kendo supports plus custom ones needed
var restricted = {
    "0": true,
    "9": true,
    "#": true,
    "L": true,
    "?": true,
    "&": true,
    "C": true,
    "A": true,
    "a": true,
    ".": true,
    ",": true,
    "$": true,
    "*": true,
    "l": true,
    "u": true,
    "\\": true
};
//Raw character that should be shown as-is
Raw.prototype.toKendo = function() {
    if (this.char === undefined) {
        return "";
    } else if (restricted.hasOwnProperty(this.char)) {
        return "\\" + this.char;
    } else {
        return this.char;
    }
};
Raw.prototype.toExample = function() {
    if (this.char === undefined) {
        return [""];
    } else {
        return [this.char];
    }
};

/**
 * Convert a string into an array of token classes.
 * @param input
 * @returns {Array}
 */
var tokenize = function(input) {
    var raw = input.split("");
    var parsed = [];
    var now;
    while (raw.length) {
        now = raw.shift();
        switch (now) {
            case "#":
                parsed.push(new NumberToken());
                break;
            case "C":
            case "@":
                parsed.push(new Alpha());
                break;
            case "U":
                parsed.push(new Upper());
                break;
            case "L":
                parsed.push(new Lower());
                break;
            case "A":
                parsed.push(new AlphaNumber());
                break;
            case "?":
            case "*":
                parsed.push(new Wild());
                break;
            case "\\":
                //Process 2 characters
                parsed.push(new Raw(raw.shift()));
                break;
            default:
                parsed.push(new Raw(now));
                break;
        }
    }
    return parsed;
};

/**
 * Parse a DocFinity formatted mask.
 * @param input mask
 * @constructor
 */
var Mask = function(input) {
    this.tokens = tokenize(input || "");
};

/**
 * Convert the mask into syntax friendly to the DFMaskedInput control.
 * @returns {*|string}
 */
Mask.prototype.toKendo = function() {
    return this.tokens.map(function(one) {
        return one.toKendo();
    }).join("");
};

/**
 * Convert the mask into an example string that matches.
 * This should be stable(same input->same output across all invocations).
 * Does not use the same character every time for each wildcard
 * @returns {*|string}
 */
Mask.prototype.toExample = function() {
    var i = 0;
    return this.tokens.map(function(one) {
        var examples = one.toExample();
        return examples[i++ % examples.length];
    }).join("");
};

export default Mask;